// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"5":"0d8954a5","81":"fcd4aa6e","340":"226e2f95","494":"a00b7b35"}[chunkId] + ".js";
};